import {Usage} from '../common/UsageSchema';
import {ServiceIntervalSummaryResponse} from './ServiceIntervalSummaryResponseSchema';

export type ServiceIntervalSummaryUseCaseResult = {
  result: ServiceIntervalSummaryResponse;
  usage: Usage;
};
